import {Badge, Group, Paper, Stack, Text, UnstyledButton} from '@mantine/core'
import {Link} from '@tanstack/react-router'

import {PartialPickupIcon} from '../work/partial-pickup'
import classes from './job-list-card.module.css'
import {formatDateTbcLabel, formatJobDate} from './job-schedule-format'
import {JobStatusBadge} from './job-status-badge'
import type {JobListItem} from './types'

type JobListCardProps = {
    job: JobListItem
    createdAtLabel: string
}

export function JobListCard({job, createdAtLabel}: JobListCardProps) {
    const scheduleLabel = job.dateTbc
        ? formatDateTbcLabel(job.startTime)
        : job.endDate != null
          ? `${formatJobDate(job.startDate)} – ${formatJobDate(job.endDate)}`
          : formatJobDate(job.startDate)

    return (
        <UnstyledButton
            component={Link}
            to="/jobs/$jobId"
            params={{jobId: job.id}}
            className={classes.cardLink}
            aria-label={`View job ${job.name}`}
        >
            <Paper withBorder p="md" radius="md" className={classes.card}>
                <Group justify="space-between" align="flex-start" wrap="nowrap" mb="sm">
                    <Stack gap={2} style={{flex: 1, minWidth: 0}}>
                        <Group gap="xs" align="center" wrap="nowrap">
                            <Badge variant="light" size="sm">
                                {job.displayId}
                            </Badge>
                            <Text fw={600} size="lg" truncate>
                                {job.name}
                            </Text>
                            <PartialPickupIcon partialPickup={job.partialPickup} />
                        </Group>
                        <Text size="sm" c="dimmed" truncate>
                            {job.customerName}
                        </Text>
                    </Stack>
                    <JobStatusBadge status={job.status} />
                </Group>

                <Stack gap={4}>
                    <Text size="sm">
                        <Text span c="dimmed">
                            Category:{' '}
                        </Text>
                        {job.serviceTypeName}
                    </Text>
                    <Text size="sm">
                        <Text span c="dimmed">
                            Schedule:{' '}
                        </Text>
                        {scheduleLabel}
                    </Text>
                    <Text size="sm" c="dimmed">
                        Created {createdAtLabel}
                    </Text>
                </Stack>
            </Paper>
        </UnstyledButton>
    )
}
